<template>
  <IAMEntityMutationModal
    :loading="loading"
    :entity="organisation"
    :show-name="true"
    :show-coc-number="true"
    :create-title-key="'iam.organisations.header.create_organisation'"
    :update-title-key="'iam.organisations.header.update_organisation'"
    :name-placeholder-key="'iam.organisations.name_placeholder'"
    :description-placeholder-key="'iam.organisations.description_placeholder'"
    :coc-number-placeholder-key="'iam.organisations.cocNumber_placeholder'"
    :address-placeholder-key="'iam.organisations.address_placeholder'"
    :postal-code-placeholder-key="'iam.organisations.postalCode_placeholder'"
    :city-placeholder-key="'iam.organisations.city_placeholder'"
    :region-placeholder-key="'iam.organisations.region_placeholder'"
    :website-placeholder-key="'iam.organisations.website_placeholder'"
    :email-placeholder-key="'iam.organisations.email_placeholder'"
    :external-id-placeholder-key="'iam.organisations.externalId_placeholder'"
    :type-options="typeOptions"
    :type-disabled="isImmutableType"
    @close="emit('close')"
    @mutate="handleMutate"
  />
</template>

<script setup lang="ts">
import { IAMEntityMutationModal } from '@infuse/iam/components';
import { CreateOrganisation, Organisation, UpdateOrganisation } from '@infuse/api/iam/organisation';
import { computed } from 'vue';
import { organisationTypeOptions, useIsImmutableOrganisationType } from './organisation-type-options';

const props = withDefaults(
  defineProps<{
    loading?: boolean;
    organisation?: Organisation;
  }>(),
  {
    loading: false
  }
);

interface Emits {
  (event: 'close'): void;
  (event: 'mutate', vars: { id: string | undefined; organisation: CreateOrganisation | UpdateOrganisation }): void;
}

const emit = defineEmits<Emits>();

const typeOptions = computed(() => organisationTypeOptions.value);

// Some types are fixed once set; the backend rejects a change either way.
const isImmutableType = useIsImmutableOrganisationType(() => props.organisation?.type);

const handleMutate = ({ id, entity }: { id: string | undefined; entity: any }) => {
  emit('mutate', {
    id,
    organisation: {
      name: entity.name,
      cocNumber: entity.cocNumber,
      description: entity.description,
      externalId: entity.externalId,
      address: entity.address,
      postalCode: entity.postalCode,
      city: entity.city,
      country: entity.country,
      region: entity.region,
      website: entity.website,
      email: entity.email,
      type: entity.type
    }
  });
};
</script>
